import type { SVGProps } from 'react';
const SvgAddToHomeScreen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#add_to_home_screen_svg__a)">
      <path
        fill="currentColor"
        d="M18 1.01 8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99ZM10 15h2V8H5v2h3.59L3 15.59 4.41 17 10 11.41V15Z"
      />
    </g>
    <defs>
      <clipPath id="add_to_home_screen_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAddToHomeScreen;
